export default class FaqItem {
  constructor (data) {
    this.id = data.id
    this.question = data.question || ''
    this.answer = data.answer || ''
    this.sort = data.sort || 0
  }
}
